export default __webpack_public_path__ + "static/media/Leggings of the Haunter in the Dark.6cd71cf2.jpg";